import { render } from "./AutoPass.vue?vue&type=template&id=412f2d50"
import script from "./AutoPass.vue?vue&type=script&lang=js"
export * from "./AutoPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__